// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'firebase',
  firebaseConfig: {
    apiKey: 'AIzaSyDQrEF8ALU0ihKDQuGlJ_WTlYNnlyy1ig4',
    authDomain: 'radlot-7cd52.firebaseapp.com',
    projectId: 'radlot-7cd52',
    storageBucket: 'radlot-7cd52.appspot.com',
    messagingSenderId: '574728487427',
    appId: '1:574728487427:web:bb626a6654cf60326fc436',
    measurementId: 'G-JRWMQZ7ZED',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
